import { render, staticRenderFns } from "./SettingsPaymentCategories.vue?vue&type=template&id=84768e6c"
import script from "./SettingsPaymentCategories.vue?vue&type=script&lang=js"
export * from "./SettingsPaymentCategories.vue?vue&type=script&lang=js"
import style0 from "./SettingsPaymentCategories.vue?vue&type=style&index=0&id=84768e6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports